module.exports = __webpack_public_path__ + "img/header_middle_bg.dc9b8bb7.png";